<template>

    <section id="new_ref_fifth_step" class="flex" v-if="associatedRef">


        <titlePage>
            <template slot="titleBody">
                <div class="hero-head has-text-centered" >
                    <h1 class="title has-text-weight-light is-size-1 ">{{ currentEval.candidate_first_name }} {{ currentEval.candidate_last_name }}</h1>
                    <h2 class="associated_ref_name">{{ $t('modules.evaluations.formStep5.associatedRef') }} : <span>{{ getRefName(associatedRef) }}</span></h2>
                </div>
            </template>
        </titlePage>

        <div class="hero subsection_container">
            <div class="hero-body">
                <div class="container mini-container bottom-section has-text-centered">
                    <h2 class="title is-size-1 has-text-weight-bold stepTitle">{{ $t('modules.evaluations.formStep5.title') }}</h2>
                    <h3 class="subtitle email_notice" >{{ $t('modules.evaluations.formStep5.notice') }}</h3>
                    <!-- <button @click="sendEval">save</button> -->
                </div>
            </div>
            <div class="hero-foot">
                <div class="container mini-container bottom-section">

                    <div class="bottom_btn_container evals_actions">
                        <btnUnderline link="/evaluations">
                            <span v-html="$t('modules.evaluations.formStep5.btnLink1')"></span>
                        </btnUnderline>
                        <btnUnderline :link="'/evaluations/' + currentEval.id ">
                            <span v-html="$t('modules.evaluations.formStep5.btnLink2')"></span>
                        </btnUnderline>
                        <btnUnderline @actionClick="reinitNew" >
                            <span v-html="$t('modules.evaluations.formStep5.btnLink3')"></span>
                        </btnUnderline>
                    </div>

                </div>
            </div>
        </div>

    </section>

</template>

<script>
import titlePage from "@/components/layouts/titlePage"

export default {
    name: 'formEvalStep5',
    components: {
        titlePage
    },
    data(){
        return {
            createdEval: {}
        }
    },
    activated(){
        this.$store.dispatch('EvalStore/createEval', {evaluation: this.currentEval, associated_ref: this.associatedRef})
    },
    computed: {
        currentEval(){
            return this.$store.state.EvalStore.currentEval
        },
        associatedRef(){
            return this.$store.state.EvalStore.associatedRef
        }
    },
    methods: {
        getRefName(refItem){
            return refItem.job_titles[this.$i18n.locale]
        },
        reinitNew(){
            this.$store.dispatch('EvalStore/initNew')
        }
    }
}

</script>

<style lang="scss" >
#new_ref_fifth_step{
    background: $white;

    display: flex;
    flex-direction: column;
    .subsection_container{
        background: $white;
        .hero-body{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 100px;
            .stepTitle{
                max-width: 500px;
                text-align: center;
            }
        }
    }
    .bottom_btn_container{
        display: flex;
        justify-content: space-around;
    }
    .evals_actions{
        .btn_underline{
            width: 240px;
        }
    }
    .email_notice{
        margin-top: 20px;
        max-width: 500px;
        margin: 20px auto 0;
        color: $grey;
    }
}
</style>